import 'bootstrap'
import 'backbone'
import 'js-cookie'
import 'jquery-ujs'

import './upcounsel'
import './utils/init_rating_dimensions'
import './utils/kiss_events'
import './utils/net'
import './utils/floating_point'
import './utils/notification'

import './components/currency_input.jquery'
import './components/button_loader'
import './components/popdown.jquery'
import './components/content_pages'
import './components/jquery.truncate_toggle'
import './components/geo_location'
import './components/_lawyers_nav'
import './components/mobile_nav'
import './components/search'
import './components/fees_popover'
import './components/notifications'
import './components/confirm_modal'

import './views/public/content_pages/_show_article'
import './views/public/content_pages/show'
import './views/public/search/search'

import './modals/public/quote_calculator'

!function() {

  function initSubNav() {

    if ($('.sticky-sub-nav').length != 1) {
      return;
    }

    $(window).scroll(function() {
      var scrollTop = $(document).scrollTop(),
        nav = $('.section-nav'),
        nav_wrap = nav.closest('.section-nav-wrap'),
        footer = $('.sticky-footer');

      if (!UC.utils.isMobileViewPort() && scrollTop >= nav_wrap.offset().top) {
        nav.addClass('fixed');
        footer.addClass('active');
      } else {
        nav.removeClass('fixed');
      }
    }).scroll();

    $('.section-nav-wrap .section-nav-tab').on('click', function(e) {
      var $this = $(this),
          nav_wrap = $this.closest('.section-nav-wrap'),
          scrollTop = $(document).scrollTop(),
          id = $this.attr('href') || $this.find('a').attr('href'),
          hasHash = (id && id.substr(0,1) == '#'),
          pastHeader = scrollTop >= nav_wrap.offset().top;

      if (UC.utils.isMobileViewPort()) {
        e.preventDefault();
        if(nav_wrap.hasClass('selected')) {
          $('.section-nav-tab.active').removeClass('active');
          $this.addClass('active');
          nav_wrap.removeClass('selected');
        } else {
          nav_wrap.addClass('selected');
        }
      } else {
        e.preventDefault();
        $('.section-nav-tab.active').removeClass('active');
        $this.addClass('active');
      }

      $('section.tab.active').removeClass('active');
      $(id).addClass('active');
      if (hasHash && pastHeader) {
        UC.utils.scrollToElement($(id), { offset: 100 });
      }

      $(id).trigger('nav-tab-clicked');
    });

    $('.section-nav-wrap .nav-link').on('click', function(e) {
      var $this = $(this),
          nav_wrap = $this.closest('.section-nav-wrap'),
          scrollTop = $(document).scrollTop(),
          href = $this.attr('href') || $this.find('a').attr('href'),
          pastHeader = scrollTop >= nav_wrap.offset().top;

      if (UC.utils.isMobileViewPort()) {
        e.preventDefault();
        if(nav_wrap.hasClass('selected')) {
          if ($this.hasClass('active')) {
            nav_wrap.removeClass('selected');
          } else {
            location.href = href;
          }
        } else {
          nav_wrap.addClass('selected');
        }
      }
    });
  }

  $(function() {

    initSubNav();

    UC.utils.initView();

    UC.utils.initNavBar();
    UC.utils.trackCopyAndContextMenu();
  });
}();
